import { BO, BusinessObjectBase, NonUniqueModelDataError, RepositoryResponseConflictCodes, ResponseConflictObject, Weaver } from '@skylab-shared/core';
import { AdjustmentReasonModel } from '@skylab-shared/dataModel';
import { sameValues } from '@skylab-shared/utils';

@BO({ modelType: AdjustmentReasonModel })
export class AdjustmentReasonBO extends BusinessObjectBase<AdjustmentReasonModel> {
    public constructor(
        weaver: Weaver
    ) {
        super(weaver);
    }

    protected override handleConflictSaveResponse(conflict: ResponseConflictObject<RepositoryResponseConflictCodes>) {
        if ((conflict.code === RepositoryResponseConflictCodes.UniqueConstraintViolation) && sameValues(conflict.objectProperties!, ['name'])) {
            this.addExternalRuleViolations({
                [this.model.sun]: [{
                    property: 'name',
                    violation: new NonUniqueModelDataError('business.adjustment-reason.validation.server-rule-violations.non-unique-model-data-error')
                }]
            });
        }
    }
}
